/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAwardBlockFragment, AwardBlockFragment, FullAwardBlockFragment} from '@amblique/contentful/app/contentful/fragments/award-block';

/**
 * Get a single AwardBlock by ID (base - scalars only)
 */
export const getBaseAwardBlockById = gql`
  ${BaseAwardBlockFragment}

  query GetBaseAwardBlockById($id: String!, $locale: String!, $preview: Boolean) {
    awardBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseAwardBlockFragment
    }
  }
`;

/**
 * Get a single AwardBlock by ID (standard - 1 level deep)
 */
export const getAwardBlockById = gql`
  ${AwardBlockFragment}

  query GetAwardBlockById($id: String!, $locale: String!, $preview: Boolean) {
    awardBlock(id: $id, locale: $locale, preview: $preview) {
      ...AwardBlockFragment
    }
  }
`;

/**
 * Get a single AwardBlock by ID (full - 2 levels deep)
 */
export const getFullAwardBlockById = gql`
  ${FullAwardBlockFragment}

  query GetFullAwardBlockById($id: String!, $locale: String!, $preview: Boolean) {
    awardBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullAwardBlockFragment
    }
  }
`;

/**
 * Get all AwardBlock entries with pagination (base - scalars only)
 */
export const getBaseAwardBlocks = gql`
  ${BaseAwardBlockFragment}

  query GetBaseAwardBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AwardBlockOrder]
    $where: AwardBlockFilter
    $preview: Boolean
  ) {
    awardBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseAwardBlockFragment
      }
    }
  }
`;

/**
 * Get all AwardBlock entries with pagination (standard - 1 level deep)
 */
export const getAwardBlocks = gql`
  ${AwardBlockFragment}

  query GetAwardBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AwardBlockOrder]
    $where: AwardBlockFilter
    $preview: Boolean
  ) {
    awardBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...AwardBlockFragment
      }
    }
  }
`;

/**
 * Get all AwardBlock entries with pagination (full - 2 levels deep)
 */
export const getFullAwardBlocks = gql`
  ${FullAwardBlockFragment}

  query GetFullAwardBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AwardBlockOrder]
    $where: AwardBlockFilter
    $preview: Boolean
  ) {
    awardBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullAwardBlockFragment
      }
    }
  }
`;
